<template>
  <h1>Take a look page</h1>
</template>

<script>
export default {};
</script>

<style></style>
